import { FlexBox } from "@brg/ui";
import { LayoutConst } from "core";
import styled from "styled-components";

export const ConfirmWrapper = styled.div`
    position: absolute;
    z-index: 999999;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
`;

export const ConfirmContent = styled(FlexBox)`
    position: fixed;
    z-index: 999999;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 540px;
    max-width: calc(100vw - 32px);
    background-color: #fefefe;
    padding: 32px 40px 40px;
    box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.20);
    border-radius: 8px;
    gap: 16px;
    box-sizing: border-box;

    @media (max-width: ${LayoutConst.screen.s}px) {
        padding: 16px;
    }
`;

export const ConfirmTitle = styled.div`
    font-size: 22px;
    font-weight: 600;
    line-height: 28px;
    letter-spacing: -0.44px;
    color: #151514;
`;

export const ConfirmDescription = styled.div`
    font-size: 15px;
    font-weight: 400;
    line-height: 22px;
    color: #151514;
`;
import { FlexBox } from "@brg/ui";
import { LayoutConst } from "core";
import styled from "styled-components";

export const ConfirmWrapper = styled.div`
    position: absolute;
    z-index: 999999;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
`;

export const ConfirmContent = styled(FlexBox)`
    position: fixed;
    z-index: 999999;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 540px;
    max-width: calc(100vw - 32px);
    background-color: #fefefe;
    padding: 32px 40px 40px;
    box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.20);
    border-radius: 8px;
    gap: 16px;
    box-sizing: border-box;

    @media (max-width: ${LayoutConst.screen.s}px) {
        padding: 16px;
    }
`;

export const ConfirmTitle = styled.div`
    font-size: 22px;
    font-weight: 600;
    line-height: 28px;
    letter-spacing: -0.44px;
    color: #151514;
`;

export const ConfirmDescription = styled.div`
    font-size: 15px;
    font-weight: 400;
    line-height: 22px;
    color: #151514;
`;
